import { render, staticRenderFns } from "./MenuPrincipal.vue?vue&type=template&id=6675c931&scoped=true"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js"
import style0 from "./MenuPrincipal.vue?vue&type=style&index=0&id=6675c931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6675c931",
  null
  
)

export default component.exports